import {
  setArea,
  setAreaFromHash,
  setProductId,
  setImage,
  setFiltered,
  setError,
  setLoading,
  addText
} from "../actions/app";
import {
  undo,
  onTap,
  onPanStart,
  onPanMove,
  onPanEnd,
} from "../actions/preview";
import { cropActions } from "./areas/CropPhoto/actions";
import { textActions } from "../actions/text";
import { onPinchStart, onPinchMove, onPinchEnd } from "../actions/touch";
import { onMouseMove, onMouseUp, onMouseDown } from "../actions/desktop";

import { track } from '../misc/utils';

const handlers = {
  setArea(area) {
    this.setState(setArea(area));
  },
  setAreaFromHash() {
    this.setState(setAreaFromHash);
  },
  setProductId(productId) {
    this.setState(setProductId(productId));
  },
  setLoading(loading) {
    this.setState(setLoading(loading));
  },
  setError(error) {
    this.setState(setError(error));
  },
  setImage(kind, data) {
    this.setState(setImage(kind, data));
  },
  setFiltered(filtered) {
    this.setState(setFiltered(filtered));
  },
  addText(text) {
    this.setState(addText(text));
  },
  handlePinchStart(evt) {
    return onPinchStart(evt, this.state);
  },
  handlePinchMove(evt) {
    this.setState(onPinchMove(evt));
  },
  handlePinchEnd(evt) {
    this.setState(onPinchEnd(evt));
  },
  handleOnTap(evt, sticker) {
    this.setState(onTap(evt, sticker));
  },
  handleOnPanStart(evt) {
    return onPanStart(evt, this.state.mouseDown);
  },
  handleOnPanMove(evt, sticker) {
    this.setState(onPanMove(evt, sticker));
  },
  handleOnPanEnd(evt, sticker) {
    this.setState(onPanEnd(evt, sticker));
  },
  handleUndo() {
    this.setState(undo());
  },
  handleOnMouseMove(evt) {
    this.setState(onMouseMove({ ...evt }));
  },
  handleOnMouseUp(evt) {
    this.setState(onMouseUp({ ...evt }));
  },
  handleOnMouseDown(evt) {
    this.setState(onMouseDown({ ...evt }));
  },
  handleCropSlide(evt) {
    this.setState(cropActions.onSlide(evt));
  },
  handleCropPanMove(evt, pos) {
    this.setState(cropActions.onPanMove(evt, pos));
  },
  handleCropPanEnd(oldPos, newPos) {
    return cropActions.onPanEnd(oldPos, newPos);
  },
  handleCropPinchMove(evt, scale) {
    this.setState(cropActions.onPinchMove(evt, scale));
  },
  handleCropPinchEnd(oldScale, newScale) {
    return cropActions.onPinchEnd(oldScale, newScale);
  },
  setSelectedText(evt, index) {
    this.setState(textActions.onTap(index));
  },
  handleTextPanMove(evt) {
    this.setState(textActions.onPanMove(evt));
  },
  handleTextPanEnd() {
    this.setState(textActions.onPanEnd());
  },
  setTextColour(colour) {
    track.event('button', 'editor_select_text_color', colour);
    this.setState(textActions.setTextColour(colour, this.state.text.selected));
  },
  setTextFamily(fontFamily) {
    track.event('button', 'editor_select_font', fontFamily);
    this.setState(textActions.setTextFamily(fontFamily, this.state.text.selected));
  },
  setTextSize(fontSize, index, callback) {
    this.setState(textActions.setTextSize(fontSize, index, callback));
  },
  pushTextSizeAction(index) {
    this.setState(textActions.pushTextSizeAction(index));
  },
  deleteText(index) {
    track.event('button', 'click', 'text_trash');

    const textIndex = index !== undefined ? index : this.state.text.selected;
    this.setState(textActions.deleteText(textIndex));
  },
  updateText(text, index) {
    const textIndex = index !== undefined ? index : this.state.text.selected;

    this.setState(textActions.editText(text, textIndex));
  },
  handleTextUndo() {
    this.setState(textActions.handleUndo());
  }
};

export default context => {
  const obj = {};
  for (let key in handlers) {
    obj[key] = handlers[key].bind(context);
  }
  return obj;
};



// WEBPACK FOOTER //
// ./src/components/handlers.js